import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M15.47 6.47a.75.75 0 1 1 1.06 1.06zM10 13l.53.53-.53.53-.53-.53zM3.47 7.53a.75.75 0 0 1 1.06-1.06zm13.06 0-6 6-1.06-1.06 6-6zm-7.06 6-6-6 1.06-1.06 6 6z" />
  </svg>
);
export default SvgArrowDown;
